import { render, staticRenderFns } from "./CourceStudents.vue?vue&type=template&id=79e0a264&scoped=true"
import script from "./CourceStudents.vue?vue&type=script&lang=js"
export * from "./CourceStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e0a264",
  null
  
)

export default component.exports